import React, { useState } from 'react'
import DraggableItem from 'Components/Studio/Canvas/Items/_DraggableItem'
import FontFamilyDropdown from 'Components/Studio/SideMenu/TextBlock/FontFamilyDropdown'
import useFontLoader from 'Hooks/useFontLoader'
import { Font } from 'Vendor/Utils/StudioTypes'

const TYPOGRAPHY_STYLES = {
    title1: { fontSize: '32px', fontWeight: 'normal' },
    title2: { fontSize: '24px', fontWeight: 'normal' },
    title3: { fontSize: '20px', fontWeight: 'normal' },
}

interface TextBlockProps {
    platformFonts?: Font[];
}

const TextBlock: React.FC<TextBlockProps> = ({ platformFonts }) => {
    const [selectedFont, setSelectedFont] = useState<string>('')

    useFontLoader(selectedFont, platformFonts);

    return (
        <>
            <div className="my-3">
                <FontFamilyDropdown
                    label="Typography"
                    onChange={setSelectedFont}
                    value={selectedFont}
                    platformFonts={platformFonts}
                />
            </div>

            <div className="mb-3" style={{ zIndex: 0 }}>
                {Object.entries(TYPOGRAPHY_STYLES).map(([key, style]) => (
                    <DraggableItem
                        key={key}
                        id={key}
                        label="Title"
                        type="TEXT"
                        style={{ ...style, fontFamily: selectedFont }}
                    />
                ))}
            </div>
        </>
    )
}

export default TextBlock
